/**
 * Model class which will have type declaration for all MFA related operations
 * 
 */


export enum MFAActionType {
    DENY = 'DENY',
    DEVDENY = 'DEVDENY',
    CHALLENGE = 'CHALLENGE',
    CHALLENGE_SUCCESS = "CHALLENGE_SUCCESS",
    CHALLENGE_FAILURE = "CHALLENGE_FAILURE",
    ALLOW = 'ALLOW',
    ERROR = 'ERROR',
    CANCEL = 'CANCEL',
    COLLECT = 'COLLECT',
    CHALLENGE_SUCCESS_RESET = 'CHALLENGE_SUCCESS_RESET',
    CHALLENGE_SUCCESS_LOGIN = 'CHALLENGE_SUCCESS_LOGIN'
  }

export interface MFAResponse {
  mfaActionType: MFAActionType,
  challengeType?: any 
  response: any

}

export class OTPInfo {
  phoneNumber: string;
  smsInterdictionId: string;
  voiceInterdictionId: string;
}

/**
 * Call signature for the callback function that is passed to mfa service
 */
export type MFACallback = (response: MFAResponse) => void;
